import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { siteNav } from '@/mocks/nav';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const solid = scrolled || !isHome;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        solid ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span
              className={`w-9 h-9 rounded-md flex items-center justify-center text-xl ${
                solid ? 'bg-primary-500 text-background-50' : 'bg-primary-500 text-background-50'
              }`}
            >
              <i className="ri-radar-line" />
            </span>
            <span className="leading-tight">
              <span
                className={`block font-heading text-base md:text-lg font-bold tracking-wide ${
                  solid ? 'text-foreground-950' : 'text-background-50'
                }`}
              >
                爆料专区导航
              </span>
              <span
                className={`block text-[10px] md:text-xs tracking-widest ${
                  solid ? 'text-foreground-500' : 'text-background-200'
                }`}
              >
                入口 · 网址 · 讨论区
              </span>
            </span>
          </Link>

          <nav aria-label="主导航" className="hidden md:flex items-center gap-1">
            {siteNav.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : solid
                        ? 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                        : 'text-background-100 hover:text-background-50 hover:bg-white/10'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#subscribe"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-notification-3-line" />
              订阅更新
            </a>
          </div>

          <button
            type="button"
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md text-2xl cursor-pointer ${
              solid ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            <i className={open ? 'ri-close-line' : 'ri-menu-3-line'} />
          </button>
        </div>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          open ? 'max-h-96' : 'max-h-0'
        } ${solid ? 'bg-background-50' : 'bg-foreground-950/95 backdrop-blur'}`}
      >
        <nav aria-label="移动端导航" className="px-4 py-4 flex flex-col gap-1">
          {siteNav.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `px-4 py-3 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : solid
                      ? 'text-foreground-700 hover:bg-background-100'
                      : 'text-background-100 hover:bg-white/10'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <a
            href="#subscribe"
            className="mt-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
          >
            <i className="ri-notification-3-line" />
            订阅更新
          </a>
        </nav>
      </div>
    </header>
  );
}